import { TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';

export type TCreateProcessFormPayload = {
  processName: string;
  department: string[];
  uom: string[];
};

export const CREATE_PROCESS_FORM_MODEL = {
  createModel: (departments: string[], uoms: string[]): TLiftedFormModel =>
    PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: { type: 'INPUT', subType: 'text' },
          metadata: { keyName: 'processName', label: 'Process Name', isRequired: true },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            options: departments.map((d) => ({ value: d, displayName: d })),
            isMulti: false,
          },
          metadata: { keyName: 'department', label: 'Department', isRequired: true },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            options: uoms.map((u) => ({ value: u, displayName: u })),
            isMulti: false,
          },
          metadata: { keyName: 'uom', label: 'UOM', isRequired: true },
        },
      ],
    }),

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => FORM_MODIFIER.markTouchedInputs(formModel),
};
